import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PromoDiscount } from './promo-discount.model';
import { promoDiscountBuilderUI } from './promo-discount.mapper';

@Injectable({
  providedIn: 'root'
})
export class PromoDiscountService {
  baseUrl = environment.apiUrl;

  constructor(private _http: HttpClient) {}

  promoDiscountChecker(promoCode, params): Observable<PromoDiscount> {
    return this._http
      .get(`${this.baseUrl}/promos/${promoCode}/check-availability`, {
        params: params
      })
      .pipe(map(promoDiscountBuilderUI));
  }
}
